import React, { useMemo } from "react";
import { Button, Descriptions, Drawer, Space, Tag } from "antd";
import { CompressOutlined, EditOutlined, ExpandOutlined, TeamOutlined } from "@ant-design/icons";
import { formatEnumLabel } from "../constants";
import useFormattedDate from "hooks/useFormatDate";

export default function BusinessUserDetailsDrawer({ open, onClose, user, onEdit }) {
  const title = useMemo(() => {
    const name = [user?.firstName, user?.lastName].filter(Boolean).join(" ");
    return name || user?.email || "Business User";
  }, [user]);
  const { formatDateTime } = useFormattedDate();
  const [fullWidth, setFullWidth] = React.useState(false);

  return (
    <Drawer
      title={
        <Space>
          <TeamOutlined />
          <span>{title}</span>
        </Space>
      }
      width={fullWidth ? "100vw" : 560}
      styles={{
        header: { paddingLeft: fullWidth ? 48 : 24, paddingRight: 24 },
        body: { paddingLeft: fullWidth ? 48 : 24, paddingRight: 24 },
        footer: { paddingLeft: fullWidth ? 48 : 24, paddingRight: 24 },
      }}
      open={open}
      onClose={onClose}
      destroyOnClose
      placement="right"
      zIndex={2300}
      extra={
        <Space>
          <Button
            type="text"
            aria-label={fullWidth ? "Normal drawer width" : "Expand drawer"}
            title={fullWidth ? "Normal width" : "Expand"}
            icon={fullWidth ? <CompressOutlined /> : <ExpandOutlined />}
            onClick={() => setFullWidth((v) => !v)}
          />
          <Button
            type="primary"
            icon={<EditOutlined />}
            disabled={!user?.userId}
            onClick={() => onEdit?.(user)}
          >
            Edit
          </Button>
        </Space>
      }
      footer={
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>Close</Button>
        </Space>
      }
    >
      <Descriptions bordered size="small" column={1} labelStyle={{ width: 170 }}>
        <Descriptions.Item label="Name">
          {[user?.firstName, user?.lastName].filter(Boolean).join(" ") || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Email">{user?.email || "-"}</Descriptions.Item>
        <Descriptions.Item label="Phone">{user?.phone || "-"}</Descriptions.Item>
        <Descriptions.Item label="Role">
          {user?.role ? formatEnumLabel(user.role) : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          {user?.status ? <Tag>{formatEnumLabel(user.status)}</Tag> : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Primary Contact">
          <Tag color={user?.primaryContact ? "green" : "default"}>
            {user?.primaryContact ? "Yes" : "No"}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Joined At">
          {user?.joinedAt ? formatDateTime(user.joinedAt) : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {user?.createdAt ? formatDateTime(user.createdAt) : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {user?.updatedAt ? formatDateTime(user.updatedAt) : "-"}
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
}
